/* eslint-disable import/no-unresolved */
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import CustomLabel from "../../../../../shared/CustomLabel";
import CustomReviewField from "../../../../../shared/CustomReviewField";

function RidersReview() {
  const riderDetails = useAppSelector((state) => state.loanDetails?.riderDetails);
  return (
    <div>
      <div className="flex justify-between mt-10">
        <div className="text-base font-bold">Rider Details</div>
      </div>
      <div>
        {riderDetails?.map((rider, index) => (
          <div>
            {index > 0 && <hr className="mt-6" />}
            <div className="grid grid-flow-row-dense lg:grid-cols-3 grid-cols-2 gap-y-8 lg:gap-x-32 md:gap-x-36 gap-x-3 mt-6 max-sm:ml-4">
              <div className="col-span-1">
                <CustomLabel>Rider Product Selection</CustomLabel>
                <CustomReviewField>{rider?.productSelection || "-"}</CustomReviewField>
              </div>

              <div className="col-span-1">
                <CustomLabel>Rider Benefit Type</CustomLabel>
                <CustomReviewField>{rider?.benefitType}</CustomReviewField>
              </div>
              <div className="col-span-1">
                <CustomLabel>Rider Plan Options</CustomLabel>
                <CustomReviewField>{rider?.planOption || "-"}</CustomReviewField>
              </div>
              <div className="col-span-1">
                <CustomLabel>Rider Plan Sub-option</CustomLabel>
                <CustomReviewField>{rider?.subPlanOption || "-"}</CustomReviewField>
              </div>
              <div className="col-span-1">
                <CustomLabel>EMI</CustomLabel>
                <CustomReviewField>{rider?.emi || "-"}</CustomReviewField>
              </div>

              <div className="col-span-1">
                <CustomLabel>Rider PT (Months)</CustomLabel>
                <CustomReviewField>{rider?.policyTerm || "-"}</CustomReviewField>
              </div>

              <div className="col-span-1">
                <CustomLabel>Rider PPT (Years)</CustomLabel>
                <CustomReviewField>{rider?.premiumPolicyTerm || "-"}</CustomReviewField>
              </div>
              <div className="col-span-1">
                <CustomLabel>Rider Sum Assured</CustomLabel>
                <CustomReviewField>{rider?.sumAssured || "-"}</CustomReviewField>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
export default RidersReview;
